import { gql } from 'apollo-boost';

export const GET_BLACK_LIST = gql`
  query blackList {
    blackList {
        id
        url
        reason
    }
  }
`;

export const GET_BLACK_LIST_BY_ID = gql`
query blackListById($id: String!) {
  blackListById(id: $id) {
    url
    reason
    }
  }
`;

export const ADD_BLACK_LIST = gql`
  mutation createBlackList($url: String!, $reason: String!) {
    createBlackList(input: { url: $url, reason: $reason }) {
      id
      url
      reason
    }
  }
`;

export const ADD_BLACK_LISTS = gql`
  mutation createBlackLists($inputs: [BlackListInput!]!) {
    createBlackLists(
      data: {
        inputs:
          $inputs
      }
    ){
      id
      url
      reason
    }
  }
`;

export const EDIT_BLACK_LIST = gql`
  mutation updateBlackList($id: String!, $url: String!, $reason: String!) {
    updateBlackList(id: $id, input: { url: $url, reason: $reason }) {
      id
      url
      reason
    }
  }
`;

export const DELETE_BLACK_LIST = gql`
mutation deleteBlackList($id: String!) {
deleteBlackList(id: $id) {
    id
  }
}
`;
